import { render, staticRenderFns } from "./addAccountIdentModal.vue?vue&type=template&id=62b04016"
import script from "./addAccountIdentModal.vue?vue&type=script&lang=js"
export * from "./addAccountIdentModal.vue?vue&type=script&lang=js"
import style0 from "./addAccountIdentModal.vue?vue&type=style&index=0&id=62b04016&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports